<template>
  <div
    :class="
      `spacer__item ${push ? `push-${push}` : ''} ${
        grow ? 'spacer__item--grow' : ''
      }`
    "
  >
    <slot></slot>
  </div>
</template>
<script>
/** Use spacer item to push an item to the side in mks-spacer
 * @version 1.5.1
 */
export default {
  name: "MksSpacerItem",
  props: {
    /** Push to `left`, `right`, `top`, or `bottom` */
    push: {
      type: String,
      default: null,
      validator: value => {
        return value.match(/(left|right|top|bottom)/);
      }
    },
    /** Make the item use all the available space
     * @version 1.5.2
     */
    grow: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="scss">
.spacer,
.spacer > .spacer {
  .spacer__item.push-left {
    @include push-left;
  }
  .spacer__item.spacer__item.push-right {
    @include push-right;
  }
  .spacer__item.spacer__item.push-top {
    @include push-top;
  }
  .spacer__item.spacer__item.push-bottom {
    @include push-bottom;
  }
}

.spacer__item--grow {
  flex-grow: 1;
}
</style>

